import { useQuery } from '@tanstack/react-query'
import { getNotificationSubscriptions } from 'services/notificationSubscriptions'

const useNotificationSubscriptions = userId => {
  const { data: userSubscriptions, isPending: subscriptionsLoading } = useQuery({
    queryKey: ['getNotificationSubscriptions', userId],
    queryFn: () => getNotificationSubscriptions({ userId: userId }),
    enabled: !!userId,
  })

  return {
    userSubscriptions,
    subscriptionsLoading,
  }
}

export { useNotificationSubscriptions }
